<template>
  <div class="elite-tabs-wrapper-content">
    <log-list-table :filterSubject="transaction" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "elixiopay-transaction-view-logs",

  components: { LogListTable },

  props: ["transaction"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
